// Returns the best thumbnail URL for a normalized video block, or null.
// `video_thumbnails` is an open map of named variants ({ default, mobile, ... })
// managed by the backend thumbnail system; unknown variant keys may appear later.
// The legacy single-URL `video_poster` field is only a last-resort fallback.
export default function videoThumbnailUrl(block, { mobile = false } = {}) {
  const thumbnails = block?.video_thumbnails;
  if (thumbnails && typeof thumbnails === "object") {
    if (mobile && thumbnails.mobile) return thumbnails.mobile;
    if (thumbnails.default) return thumbnails.default;
    const firstVariant = Object.values(thumbnails).find(Boolean);
    if (firstVariant) return firstVariant;
  }
  return block?.video_poster || null;
}
